import {UserAuthenticationBaseRequestDto, UserAuthenticationBaseResponseDto} from '../user-authentication-base.dto';
import {AutoMap} from '@automapper/classes';

export class SignUpRequestDto extends UserAuthenticationBaseRequestDto {
  @AutoMap()
  public firstName!: string

  @AutoMap()
  public lastName!: string | null

  @AutoMap()
  public email!: string

  @AutoMap()
  public verificationCode!: string
}

export class SignUpResponseDto extends UserAuthenticationBaseResponseDto {

}
